import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody31';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy31 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'> Public Equity Screening And Industry </h2><h4>Benchmarking for a Saudi based family office</h4>";

  return (
    <>
        <Helmet>
        <title>Public Equity Screening And Industry Benchmarking for a Saudi based family office</title>
        <meta property="og:title" content="Public Equity Screening And Industry Benchmarking for a Saudi based family office" />
        <meta property='og:description' content='Public Equity Screening And Industry Benchmarking for a Saudi based family office'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy31" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy31
